export const apiRoutes = {
  getDistributorCatalogs: '/catalog/graphql/public',
  forgotPasswordEndpoint: `${process.env.REACT_APP_OKTA_URI}/api/v1/authn/recovery/password`,
  opportunities: `${process.env.REACT_APP_API_ENDPOINT}/opportunities/`,
  orders: `${process.env.REACT_APP_API_FORM_ENDPOINT}/orders/`
};
